import React from 'react';
import {NavLink} from 'react-router-dom';
import {consultancySteps} from 'data/ConsultancySteps';
import WorkingStep from 'pages/Consultancy/components/WorkingStep/WorkingStep';

const ConsultancySteps = () => {
    return (
        <section className="steps-working-section">
            <div className="container">
                <h1 className="fw-bold" data-aos="fade-down" data-aos-duration="2000">
                    How Anuyog Consultancy Works
                </h1>
                <h4 className="fw-bold offering-title">
                    It's a journey, and together, we'll walk the path to your goal.
                </h4>

                <div className="consultancy-step">
                    {consultancySteps.map((step) => (
                        <WorkingStep
                            key={step.id}
                            stepNumber={step.stepNumber}
                            title={step.title}
                            description={step.description}
                            image={step.image}
                            color={step.color}
                            className={step.className}
                        />
                    ))}
                </div>

                <div className="how mt-4">
                    <NavLink
                        to="/contact"
                        onClick={() => {
                            window.scrollTo(0, 0);
                        }}
                    >
                        <button type="button" className="btn">Book a Free Discovery Call</button>
                    </NavLink>
                </div>
            </div>
        </section>
    );
};

export default ConsultancySteps;
